<section 
  class="offers"
  [class.fromBottomSheet]="fromBottomSheet()"
>
  <div class="offers__header">
    <h3 
      class="ci-heading-h3-s-bold offers__title"
    >
      {{ 'Ofertas' | translate }}
    </h3>
      <offers-navigation-buttons [offersList]="offersList" />
  </div>
    
  <article #offersList class="offers__list">
      @for (offer of offers(); track offer){
        <!-- <app-standard-card class="offers__list__new-item" [class.skeleton]="!this.corpColor()" [class.skeleton-hide]="this.corpColor()" (click)="openOfferModal($event, offer, '0ms', '150ms')" [data]="offer" /> -->
        <details-offer class="offers__list__new-item" [offer]="offer" />
      }
  </article>
</section>